/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Userid2Inputs */

const en__field_userid2 = /** @type {(inputs: _Field_Userid2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`User reference (intern)`)
};

const de__field_userid2 = /** @type {(inputs: _Field_Userid2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nutzer Referenz (intern)`)
};

/**
* | output |
* | --- |
* | "User reference (intern)" |
*
* @param {_Field_Userid2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_userid2 = /** @type {((inputs?: _Field_Userid2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Userid2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_userid2(inputs)
	return de__field_userid2(inputs)
});
export { _field_userid2 as "_field_userID" }